export default class GelSubtitles {
    constructor() {
        this._timeout = null;

        this._htmlElement = $("<div id='subtitles' tabIndex='-1'></div>");
        this._htmlElement.css({
            "font-family"       : "BBC Reith Sans",
            "position"          : "fixed",
            "bottom"            : "4%",
            "left"              : "10%",
            "width"             : "80%",
            "text-align"        : "center",
            "font-size"         : PIXI.utils.isMobile.any ? "1.5em" : "2.0em",
            "color"             : "#FFFFFF",
            "background-color"  : "rgba(0, 0, 0, 0.8)",
            "z-index"           : 20,
            "pointer-events"    : "none"
        });
        $("#" + P3.View.holder.id).append(this._htmlElement);
    }

    show(text, duration) {
        duration = duration || 2;
        this._htmlElement.html(text);

        this._timeout && this._timeout.stop();
        this._timeout = P3.utils.delay(duration, () => {
            this.clear();
        });
    }

    clear() {
        this._htmlElement.html("");
    }

    get visible() {
        return this._htmlElement.is(":visible");
    }

    set visible(value) {
        if (value) this._htmlElement.show();
        else this._htmlElement.hide();
    }
}